import React, { FC } from 'react';
import { FormControlLabel, Radio } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TextButton, TextButtonClassNames } from '../../../commons/buttons/TextButton';
import { IPaymentCard, IPaymentCards } from '../../../../models/PaymentCard';
import MastercardWebp from '../../../../assets/images/topUpBankCard/mastercard.webp';
import MastercardPng from '../../../../assets/images/topUpBankCard/mastercard.png';
import { ImgWebp } from '../../../commons/ImgWeb';
import { getCreditCardType } from '../../../../utils';
import Visa from '../../../../assets/images/topUpBankCard/visa.png';
import UnknownCard from '../../../../assets/images/topUpBankCard/unknownCard.png';
import { FormInputRadio } from '../../../inputs/FormInputRadio';
import { CardSystem, UnknownCardSystem } from '../../../../models/Common';

interface PaymentCardsSelector {
  handleChange: (cardId: string) => void;
  handleAddNewCard: () => void;
  handleDeleteCard: (cardId: string, cardNumber: string, isActiveCard: boolean) => void;
  paymentCards: IPaymentCards | undefined;
  isRadioDisabled: boolean;
  regularPaymentCard: IPaymentCard | null | undefined;
}

export const PaymentCardsSelector: FC<PaymentCardsSelector> = ({
  handleChange,
  handleAddNewCard,
  paymentCards,
  handleDeleteCard,
  isRadioDisabled,
  regularPaymentCard,
}) => {
  const { t } = useTranslation();
  return (
    <div className="payment-cards-selector">
      {paymentCards && (
        <FormInputRadio
          name="paymentCard"
          options={
            <>
              {paymentCards.list.map((card) => {
                return (
                  <div className="payment-cards-selector__card-container" key={card.id}>
                    <div className="payment-cards-selector__card">
                      <div className="payment-cards-selector__card__content">
                        {getCreditCardType(card.Card) === CardSystem.MASTERCARD && (
                          <ImgWebp webpSrc={MastercardWebp} fallback={MastercardPng} alt="mastercard" />
                        )}
                        {getCreditCardType(card.Card) === CardSystem.VISA && <ImgWebp fallback={Visa} alt="visa" />}
                        {getCreditCardType(card.Card) === UnknownCardSystem.NEW_CARD_DEFAULT && (
                          <ImgWebp fallback={UnknownCard} alt="unknown" />
                        )}
                        <div className="payment-cards-selector__card__description">
                          <p className="payment-cards-selector__card__description__label">
                            {getCreditCardType(card.Card) === UnknownCardSystem.NEW_CARD_DEFAULT
                              ? t('accountSettings.autoReplenishmentUnknownBankCard')
                              : getCreditCardType(card.Card)}
                          </p>
                          <p className="payment-cards-selector__card__description__value">{card.Card}</p>
                        </div>
                        <FormControlLabel
                          value={card.id}
                          control={
                            <Radio
                              onChange={(event) => {
                                handleChange(event.target.value);
                              }}
                              disabled={isRadioDisabled}
                              className="input input__radio"
                            />
                          }
                          label=""
                        />
                      </div>
                    </div>
                    <TextButton
                      label={t('buttons.deleteCard')}
                      handleClick={() =>
                        handleDeleteCard(
                          `${card.id}`,
                          card.Card,
                          regularPaymentCard && card.id === regularPaymentCard?.id ? card.RecurringPayIsActive : false,
                        )
                      }
                      className={TextButtonClassNames.Red}
                    />
                  </div>
                );
              })}
              <TextButton
                label={`${t('buttons.addCard')} +`}
                handleClick={handleAddNewCard}
                className={`${TextButtonClassNames.PrimaryActive} payment-cards-selector__add-new-card payment-cards-selector__card`}
              />
            </>
          }
        />
      )}
    </div>
  );
};
